import React, { PureComponent } from 'react';
import { func } from 'prop-types';

import generateServices from './generateServices';

export default (serviceConfig = []) => (WrappedComponent) => {
  if (!serviceConfig.length) {
    return WrappedComponent;
  }

  class WrapperComponent extends PureComponent {
    static propTypes = {
      messageHandler: func,
    }

    static defaultProps = {
      messageHandler: undefined,
    }

    state = {}

    render() {
      const {
        show, hide, messageHandler, ...rest
      } = this.props;
      const { message: stateMessage } = this.state;

      const services = generateServices({
        serviceConfig,
        serviceActionHandlers: {
          show, hide, messageHandler: messageHandler || (message => this.setState({ message })),
        },
        ...rest,
      });
      return (
        <WrappedComponent message={stateMessage} {...rest} services={services}/>
      );
    }
  }

  return WrapperComponent;
};
